export default "__VITE_ASSET__CKmsi7VY__"